import PropTypes from "prop-types"

const PersonCardShape = {
  employeeId: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  statusId: PropTypes.number.isRequired,
  statusTranslationIdentifier: PropTypes.string.isRequired,
}
export default PersonCardShape



// WEBPACK FOOTER //
// ./src/state/shapes/PersonCardShape.js